import React from "react";
import Button from "@mui/material/Button";
import { FilterIcon } from "../Icons/Icons";
import classes from "./filters.module.css";

/**
 * Toolbar trigger that opens the FilterDrawer.
 * Props:
 *  - onClick: () => void
 *  - activeCount: number (how many filters are currently active; shows a badge)
 */
const FilterButton = ({ onClick, activeCount = 0 }) => {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      className={classes.filterButton}
    >
      <FilterIcon />
      <span>Filters</span>
      {activeCount > 0 && (
        <span className={classes.filterCount}>{activeCount}</span>
      )}
    </Button>
  );
};

export default FilterButton;
